import { protectedApi } from '../../../../../config/api.config'

const BASE = '/cartes-acces'

export const caGet = async (path, params) => {
  const { data } = await protectedApi.get(`${BASE}${path}`, { params })
  return data
}

export const caPost = async (path, body) => {
  const { data } = await protectedApi.post(`${BASE}${path}`, body)
  return data
}

export const caPut = async (path, body) => {
  const { data } = await protectedApi.put(`${BASE}${path}`, body)
  return data
}

export const caPatch = async (path, body) => {
  const { data } = await protectedApi.patch(`${BASE}${path}`, body)
  return data
}

export const caDelete = async (path) => {
  const { data } = await protectedApi.delete(`${BASE}${path}`)
  return data
}

export const caUploadImage = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await protectedApi.post(`${BASE}/upload/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export const caUploadCentreImage = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await protectedApi.post(`${BASE}/centres/upload/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export const facilityValue = (facilityType, id) => {
  if (id == null || id === '') return null
  const str = String(id)
  if (str.includes(':')) return str
  const prefix = facilityType === 'centre_bien_etre' ? 'centre' : 'hotel'
  return `${prefix}:${id}`
}
